import * as React from "react";
import {Flex, FormInput, InputProps, Text} from "@fluentui/react-northstar";
import languageObject from "../../../translations";

type Props = {
    title: string,
    onChangeTitle: (e: React.SyntheticEvent, data: InputProps | undefined) => void,
    disabled: boolean,
}

export const TitleInput = (props: Props) => {
    const {title, onChangeTitle, disabled} = props;
    return (
        <FormInput
            fluid
            inverted
            label={
                <Flex styles={{gap: "3px"}}>
                    <Text content={languageObject.translate("Title")}/>
                    <Text styles={{color: "red"}} content={"*"}/>
                </Flex>
            }
            value={title}
            onChange={onChangeTitle}
            placeholder={languageObject.translate("EnterListName")}
            disabled={disabled}
        />
    )
}